import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { AppService } from '../../services/app.service';
import { TranslatePipe } from '@ngx-translate/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
  animations: [
    trigger('popup', [
      state('open', style({
        opacity: 1,
        transform: 'scale(1)'
      })),
      state('closed', style({
        opacity: 0,
        transform: 'scale(0)'
      })),
      transition('open <=> closed', [
        animate('0.3s ease-in-out')
      ]),
    ])
  ]
})
export class TermsComponent {
  popup: HTMLElement | null = null;
  focusableElements!: NodeListOf<HTMLElement>;
  tabIndex: number = 0;

  private $appData: Subscription;
  data: any = {}

  private $termsStatus: Subscription;
  termsStatus: boolean = false;

  //-- CONSTRUCTOR -----------------------------------------------------|
  
  constructor(private apiService: ApiService, private appService: AppService) {
    this.$appData = this.apiService.$appData.subscribe(data => { this.applyValues(data); });    
    this.$termsStatus = this.appService.$termsStatus.subscribe((status) => { this.onShowTermsChange(status) });
  }

  //-- UTILITY METHODS -------------------------------------------------|

  applyValues(res: any) {
    this.data = res;
  }

  //-- EVENTS ----------------------------------------------------------|

  onClose() {
    this.appService.changeTermsVisibility();
    document.removeEventListener('keydown', this.trapFocus);
  }


  trapFocus(event: KeyboardEvent) {
    this.tabIndex++;
    if (event.key === 'Tab') {
      if(this.tabIndex == this.focusableElements.length - 1) {
        this.tabIndex = 0;
      }
      this.focusableElements[this.tabIndex].focus();
    } else if (event.key === 'Escape') {
      this.onClose();
    }
  }

  onShowTermsChange(show: boolean) {
    this.termsStatus = show
    if (show) {
      
      this.trapFocus = this.trapFocus.bind(this);

      this.popup = document.getElementById('terms');
      if(!this.popup) return;
      this.focusableElements = this.popup.querySelectorAll('a, button, input, [tabindex="0"]');
      this.tabIndex = 0;
      document.addEventListener('keydown', this.trapFocus);

      if (!this.focusableElements) return;
      setTimeout(()=> {this.focusableElements[this.tabIndex].focus();}, 0)
      
    } else {
      document.removeEventListener('keydown', this.trapFocus);
      // document.getElementById("footnote1").focus()
    }
  }

  //-- INITIALIZE ------------------------------------------------------|
    
  ngOnInit() {
    const data = this.apiService.getData();
    this.applyValues(data);
    
  }

  //-- DESTORY ---------------------------------------------------------|

  ngOnDestroy() {
    if (this.$appData) { this.$appData.unsubscribe(); }
    if( this.$termsStatus) { this.$termsStatus.unsubscribe(); }
  }
}
